import { useEffect, useRef } from "react";

import { SuggestionProps } from "./suggestion";
import createSuggestion from "./suggestion";

// You can extend this to also support hashtag suggestions similarly
export function useMentionSuggestions(
  trigger: string,
  suggestions: SuggestionProps[],
) {
  const suggestionRef = useRef<SuggestionProps[]>(suggestions);

  useEffect(() => {
    suggestionRef.current = suggestions;
  }, [suggestions]);

  return createSuggestion(trigger, suggestionRef);
}
